
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.25 18a3.754 3.754 0 01-3.75-3.75c0-2.068 1.682-3.75 3.75-3.75S9 12.182 9 14.25A3.754 3.754 0 015.25 18zm0-6C4.009 12 3 13.009 3 14.25s1.009 2.25 2.25 2.25 2.25-1.009 2.25-2.25S6.491 12 5.25 12zM9.75 24a.75.75 0 01-.75-.75c0-2.068-1.682-3.75-3.75-3.75S1.5 21.182 1.5 23.25a.75.75 0 01-1.5 0C0 20.355 2.355 18 5.25 18s5.25 2.355 5.25 5.25a.75.75 0 01-.75.75zM18.755 17.996a3.766 3.766 0 01-3.256-1.879 3.743 3.743 0 01-.5-1.867.75.75 0 111.5-.002c0 .393.104.78.3 1.12a2.253 2.253 0 003.073.828 2.254 2.254 0 00.828-3.073.75.75 0 011.3-.748 3.753 3.753 0 01-3.245 5.621zM23.25 24a.75.75 0 01-.75-.75c0-2.068-1.682-3.75-3.75-3.75S15 21.182 15 23.25a.75.75 0 01-1.5 0c0-2.895 2.355-5.25 5.25-5.25S24 20.355 24 23.25a.75.75 0 01-.75.75zM11.25 15a.747.747 0 01-.75-.75V10.5H8.25a.75.75 0 01-.75-.75v-9A.75.75 0 018.25 0h12a.75.75 0 01.75.75v9a.75.75 0 01-.75.75h-4.189l-4.28 4.28a.747.747 0 01-.531.22zm0-6a.75.75 0 01.75.75v2.689l3.22-3.22A.754.754 0 0115.75 9h3.75V1.5H9V9h2.25z"}}),_c('path',{attrs:{"d":"M11.25 4.5a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6zM11.25 7.5a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6z"}})])
          )
        }
      }
    